/*
 * File: /src/services/teamServices.js
 * Created Date: Saturday June 15th 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Sunday, 11th October 2020 9:50:25 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2020 AdBase, Inc.
 */

import { authedAxios } from '../shared/axiosWrapper';
import { AD_BASE_TEAM_PATH } from '../constants';

export default {
  /**
   * Fetch Whole Team
   */
  fetchTeam(params = {}) {
    return authedAxios.get(AD_BASE_TEAM_PATH, {
      params: {
        fullAcls: true,
        filter: params.filters,
        limit: params.limit,
        offset: params.offset,
        sort: params.sort,
        brand_ids: params.brandIds,
        queue_ids: params.queueIds,
      },
    });
  },

  /**
   * Fetch Team Member
   */
  fetchTeamMember(id) {
    return authedAxios.get(AD_BASE_TEAM_PATH + id,
      {params: {fullAcls: true}}
    );
  },

  /**
   * Add new Team Member
   */
  newTeamMember(body) {
    return authedAxios.post(AD_BASE_TEAM_PATH, body);
  },

  /**
   * Update Team Member
   */
  updateTeamMember(id, body) {
    return authedAxios.put(AD_BASE_TEAM_PATH + id, body);
  },

  setTeamMemberPhoto(id, photoAssetId) {
    return authedAxios.put(AD_BASE_TEAM_PATH + id + '/photo', {
      photo_asset_id: photoAssetId,
    });
  },

  /**
   * Delete Team Member
   */
  deleteTeamMemberById(id) {
    return authedAxios.delete(AD_BASE_TEAM_PATH + id);
  },

  resetTeamMemberPassword(id) {
    return authedAxios.post(AD_BASE_TEAM_PATH + id + '/reset');
  },

  changeTeamMemberPassword(id, password) {
    return authedAxios.put(AD_BASE_TEAM_PATH + id + '/password', { password });
  }
};
